<template>
  <dl v-if="attribute && attribute.value !== null" class="attribute has-value">
    <template v-if="showTitle && attribute.title">
      <dt :class="'text-ellipsis type-' + attribute.type">
        <!--        @TODO Do we need img here?-->
        <img :alt="attribute.icon.name" v-if="attribute.icon && attribute.icon.length > 0" :src="iconUrl" class="attribute-icon" />
        {{ attribute.title }}
      </dt>
    </template>

    <dd :class="'type-' + attribute.type + (attribute.format === 'rich text' ? ' rich-html' : '')">
      <template v-if="attribute.type === 'boolean'">
        {{ attribute.value ? '✔' : '–' }}
      </template>

      <template v-if="attribute.type === 'list'">
        <ul>
          <li v-for="(item, index) in attribute.value.split('|')" :key="index">{{ item }}</li>
        </ul>
      </template>

      <template v-else>
        <template v-if="attribute.format === 'rich text'">
          <span class="attribute-rich-text">
            {{ attribute.value }}
            <span v-if="attribute.suffix">&nbsp;{{ attribute.suffix }}</span>
          </span>
        </template>

        <template v-else-if="attribute.format === 'youtube'">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              :src="'//www.youtube.com/embed/' + attribute.value + '?rel=0'"
              class="youtube embed-responsive-item"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </template>

        <template v-else-if="attribute.format === 'link'">
          <a :href="attribute.value" target="_blank">
            {{ attribute.title || attribute.value }}
            <span v-if="attribute.suffix">&nbsp;{{ attribute.suffix }}</span>
          </a>
        </template>

        <template v-else>
          <span class="tooltipped tooltipped-n" :aria-label="stripHtml(attribute.value)">
            <span class="text-ellipsis"
                  v-if="attribute && attribute.value !== null">
              {{ formattedValue }}
              <span v-if="attribute.suffix">&nbsp;{{ attribute.suffix }}</span>
            </span>
          </span>
        </template>
      </template>
    </dd>
  </dl>
</template>

<script setup>
import { ref, watch, defineProps, computed } from 'vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true
  },
  inList: {
    type: String,
    default: 'true'
  },
  iconUrl: {
    type: String,
    required: true
  },
  showTitle: {
    type: Boolean,
    default: true
  }
});

const formattedValue = computed(() => {
  let value = props.attribute.value || '';
  if (typeof value === 'string') {
    // Replace newline characters with <br> tags
    value = value.replace(/\n/g, '<br>');
  }
  return value;
});

// Function to strip HTML from text
function stripHtml(html) {
  const tmpEl = document.createElement('DIV');
  if (!html) return '';
  tmpEl.innerHTML = html;
  return tmpEl.textContent || tmpEl.innerText || '';
}

const showTitle = ref(props.showTitle);
const attribute = ref(props.attribute);

// Watch for changes in attribute prop to update the component dynamically
watch(() => props.attribute, (newVal) => {
  attribute.value = newVal;
});
</script>

<style scoped>
/* Add any custom styles here */
</style>
